import { IMultiSelectLocation } from 'src/app/state/ui/customerService/clientsAndLocations';

export interface IServiceTask {
    id: number;
    status: number;
    plannedOn: string;
    statusDate: string;
    vehicleName: string;
    employeeName: string;
    activityCategoryId: number;
    serviceTypeId: number;
    objectCategoryId: number;
    verifySource: number;
    unitCount?: number;
    rfidCode?: string;
    notice?: string;
    externalNumber: string;
    serviceClassId?: number;
    contractItem?: IContractItem;
    attachments?: { id: number; fileName: string }[];
    attributes?: ICustomerServiceAttribute[];
    locationId: number;
}

export interface IServiceClient {
    id: number;
    status: number;
    name: string;
    shortName?: string;
    vatin?: string;
    externalNumber?: string;
    notice?: string;
    archivalDate?: string;
}

export interface INewServiceClient {
    name: string;
    shortName: string;
    vatin: string;
    externalNumber: string;
    notice: string;
}

export interface INewServiceLocation {
    name: string;
    address: {
        city: string;
        street?: string;
        streetNumber?: string;
        zip?: string;
        apartmentNo?: string;
        areaName0: string; // country
        areaName3: string; // commune
    };
    coordinate: {
        x: number | string;
        y: number | string;
    };
    notes?: string;
    externalNo?: string;
    client: string;
    groupIds?: string[];
}

export interface IServiceLocation {
    id: string;
    externalId: string;
    name: string;
    coordinate: {
        x: number | string;
        y: number | string;
    };
    address: {
        city: string;
        street?: string;
        streetNumber?: string;
        zip?: string;
        apartmentNo?: string;
        areaName0?: string; // country
        areaName3?: string; // commune
    };
    notes?: string;
    clientId?: number;
    externalNo?: string;
    client: string;
    groupIds?: string[];
}

export interface ITaskPreFetchParams {
    selectedClientsAndLocations: IMultiSelectLocation[];
    from?: string;
    to?: string;
    onlyNotAssigned?: boolean;
    includeNotPlanned?: boolean;
}

export interface IEventByRfidPreFetchParams {
    selectedClientsAndLocations: IMultiSelectLocation[];
    from?: string;
    to?: string;
    rfidFilter?: string;
    onlyNotAssigned?: boolean;
    includeNotPlanned?: boolean;
}

export interface IServiceTasksUrlParams {
    locationId: number;
    from?: string;
    to?: string;
    onlyNotAssigned?: boolean;
    includeNotPlanned?: boolean;
}

export interface IServiceContractsUrlParams {
    locationId: number;
    rfid?: string;
}

export interface IServiceContractLocationIdsParams {
    rfid: string;
}

export interface IContractsPreFetchParams {
    selectedClientsAndLocations: IMultiSelectLocation[];
    rfid?: string;
}

export interface IContractItem {
    id: number;
    startDate: string;
    stopDate?: string;
    nextOccurrenceDate?: string;
    cycleDefinition?: string;
    activityCategoryId: number;
    serviceTypeId: number;
    objectCategoryId: number;
    serviceClassId?: number;
    assetsCount: number;
    notice?: string;
    externalNumber?: number;
    contract: IContract;
    attachments?: { id: number; fileName: string }[];
    cycleId?: number;
}

export interface IContract {
    id: number;
    name: string;
    startDate: string;
    stopDate?: string;
    isActive: boolean;
}

export enum EAttributeType {
    STRING = 'string',
    INTEGER = 'integer',
    DOUBLE = 'double',
    TIME = 'time',
    DATE = 'date',
    DATETIME = 'datetime',
    BOOLEAN = 'boolean',
}

export interface ICustomerServiceAttribute {
    label: string;
    value: number | string | boolean;
    type: EAttributeType;
}
